<main class="access-page">
  <section class="access-card" aria-labelledby="access-title">
    <h1 id="access-title">Access denied</h1>
    <p>
      Your Customer Portal account is inactive or access could not be verified.
      Try again, or contact your administrator if the problem continues.
    </p>
    <button kendoButton themeColor="primary" type="button" [disabled]="retrying" (click)="retry()">
      {{ retrying ? 'Checking access...' : 'Check access again' }}
    </button>
  </section>
</main>
